
/**
 * 设备批量操作
 */
import React, { useState } from 'react';
import { Card, Form, Row, Col, Button, Input, Select } from 'antd';
import { getBatchOptTaskList } from '@/service/batchOpt';
import { useTable } from '@/utils/useTable';
import { useBatchTaskEnums } from '@/utils/useBatchTaskEnums';
import CommonTable from '@/components/commonTable';
import RenderEllipsisColumn from '@/components/renderEllipsisColumn';
import PermissionButton from '@/components/permissionButton';
import { formSearchGutter } from '@/constants/common';
import { formatTime } from '@/utils/formatTime';
import styles from '@/styles/pageContent.module.scss';
import ViewBatchTaskModal from './modal/ViewBatchTaskModal';
import CreateBatchTaskModal from './modal/CreateBatchTaskModal';

const { Option } = Select;

const DeviceParamsBatchOpt = () => {
  const [form] = Form.useForm();
  const [searchParams, setSearchParams] = useState({}); // 搜索相关的参数
  const [createModalVisible, setCreateModalVisible] = useState(false); // 新建弹窗显示状态
  const [viewModalVisible, setViewModalVisible] = useState(false); // 查看弹窗显示状态
  const [currentRecord, setCurrentRecord] = useState<any>(null); // 当前操作的记录

  // 获取枚举数据
  const { funcTypes, statuses } = useBatchTaskEnums();

  const { page, limit, loading, data, totalCount, onPageChange, getData } = useTable({
    requestFunc: getBatchOptTaskList,
    searchParams
  });

  // 搜索
  const onSearch = async (values: any) => {
    const newSearchParams = {
      taskName: values.taskName?.trim(),
      funcType: values.funcType,
      stat: values.stat
    };
    setSearchParams(newSearchParams);
  };

  // 查看详情
  const handleViewDetail = (record: any) => {
    setCurrentRecord(record);
    setViewModalVisible(true);
  };

  // 新建任务
  const handleCreate = () => {
    setCreateModalVisible(true);
  };

  // 关闭新建弹窗
  const handleCloseCreateModal = () => {
    setCreateModalVisible(false);
  };

  // 关闭查看弹窗
  const handleCloseViewModal = () => {
    setViewModalVisible(false);
    setCurrentRecord(null);
  };

  // 新建成功回调
  const handleCreateSuccess = () => {
    setCreateModalVisible(false);
    getData(); // 刷新列表
  };

  // 表格列显示
  const columns = [
    {
      title: '任务ID',
      dataIndex: 'id',
      width: 100,
      ellipsis: { showTitle: false },
      render: (value: number) => <RenderEllipsisColumn text={String(value)} />
    },
    {
      title: '任务名称',
      dataIndex: 'taskName',
      width: 180,
      ellipsis: { showTitle: false },
      render: (value: string) => <RenderEllipsisColumn text={value} />
    },
    {
      title: '功能类型',
      dataIndex: 'funcType',
      width: 150,
      ellipsis: { showTitle: false },
      render: (value: string) => {
        const funcType = funcTypes.find(item => item.value === value);
        return <RenderEllipsisColumn text={funcType?.label || value || '-'} />;
      }
    },
    {
      title: '任务状态',
      dataIndex: 'stat',
      width: 100,
      render: (value: number) => {
        const status = statuses.find(item => item.value === value);
        return status?.label || '-';
      }
    },
    {
      title: '创建人',
      dataIndex: 'createByName',
      width: 100,
      ellipsis: { showTitle: false },
      render: (value: number) => <RenderEllipsisColumn text={value} />
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      width: 170,
      render: (value: string) => formatTime(value)
    },
    {
      title: '操作',
      dataIndex: 'operate',
      width: 100,
      fixed: 'right' as const,
      render: (value: any, record: any) => {
        return (
          <div className={styles.tableOperateColumn}>
            <Button
              // operateType="/car-admin/device-params-batch-opt/detail"
              type="link"
              onClick={() => handleViewDetail(record)}
            >
              查看详情
            </Button>
          </div>
        );
      }
    }
  ];

  return (
    <Card bordered={false} className={styles.fixPageContentBox}>
      <Form onFinish={onSearch} form={form} autoComplete="off">
        <Row gutter={formSearchGutter}>
          <Col span={5}>
            <Form.Item label="任务名称" name="taskName">
              <Input placeholder="请输入任务名称" allowClear />
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item label="功能类型" name="funcType">
              <Select placeholder="请选择功能类型" allowClear>
                {funcTypes.map(item => (
                  <Option key={item.value} value={item.value}>
                    {item.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item label="任务状态" name="stat">
              <Select placeholder="请选择任务状态" allowClear>
                {statuses.map(item => (
                  <Option key={item.value} value={item.value}>
                    {item.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={2}>
            <Form.Item>
              <div className={styles.searchBox}>
                <Button type="primary" htmlType="submit">
                  查询
                </Button>
              </div>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <div className={styles.operateBox}>
        <PermissionButton
          operateType="/car-admin/device-params-batch-opt/add"
          type="primary"
          onClick={handleCreate}
        >
          新建批量任务
        </PermissionButton>
      </div>
      <CommonTable
        rowKey="id"
        columns={columns}
        dataSource={data}
        pagination={{
          total: totalCount,
          current: page,
          pageSize: limit,
          onChange: onPageChange
        }}
        loading={loading}
        // scroll={{ x: 'max-content' }}
      />
      <CreateBatchTaskModal
        visible={createModalVisible}
        onClose={handleCloseCreateModal}
        onSuccess={handleCreateSuccess}
      />
      <ViewBatchTaskModal
        visible={viewModalVisible}
        data={currentRecord}
        onClose={handleCloseViewModal}
      />
    </Card>
  );
};

export default DeviceParamsBatchOpt;